import React from 'react';
import {MainTop} from "../groups/group-container/main-top/Main-top";
import {ReactComponent as StatsIcon} from '../../../assets/navigate/stats.svg';
import {StatsTable} from "./stats-table/Stats-table";
import {StatusCalendar} from "./status-calendar/StatusCalendar";
import AuthWrapper from "../../auth-wrapper/AuthWrapper";
import {useAppDispatch, useAppSelector} from "common/hook";

export const Stats = () => {
    const statisticsData = useAppSelector(state => state.statistics)
    const {data} = statisticsData;
    const {pageCount, page, pageSize} = data.pagination;
    const dispatch = useAppDispatch()


    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Статистика'} tabs={false} setting={false} link={'/stats'} icons={<StatsIcon/>}/>
                <StatusCalendar create={false} print={true} company={data.company} groups={data.groups} page={page}/>
                <StatsTable/>
            </div>
        </AuthWrapper>
    );
};



